<template>
  <audio ref="player" :src="audioUrl" @pause="onPause" preload="none"/>
  <i class="fa fa-fw me-1" @click="onPlay"
     :class="{ 'fa-pause': playing, 'fa-play': !playing }"
     style="cursor: pointer"
  />
  <span :title="title" class="title">
    {{ text.hablante }}
  </span>
</template>
<script setup lang="ts">
import { useNcsConfig } from "ncs"
import { computed, onMounted, ref } from "vue"
import { map } from 'lodash-es'
import { useContextFields } from "~/search/context_fields"

const props = defineProps<{
  document: Record<string, any>,
  text: Record<string, any>,
  elements: Record<string, any>,
  matches: number[]
}>()

const ncsConfig = useNcsConfig()
const audioUrl = `${ncsConfig.app.relativeUrlRoot}/audio/${props.text.id}.mp3`

const player = ref<HTMLAudioElement>()
const playing = ref(false)

const onPlay = () => {
  playing.value ? player.value.pause() : player.value.play()
  playing.value = !playing.value
}

const onPause = () => {
  playing.value = false
}

const title = computed(() => {
  const fields = useContextFields(props.document, props.text, props.elements, props.matches)
  return map(fields, (v, k) => `${k}: ${v || ''}`).join('\n')
})
</script>
